import { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { TremorLogo } from '@/shared/components/ui/TremorLogo'
import { CheckCircle, XCircle, Loader2 } from 'lucide-react'
import api from '@/shared/lib/api'

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get('token')

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (!token) {
      setStatus('error')
      setMessage('Lien de vérification invalide.')
      return
    }

    api.post('/auth/verify-email', { token })
      .then(() => {
        setStatus('success')
        setMessage('Votre email a été vérifié avec succès !')
      })
      .catch((err: any) => {
        setStatus('error')
        setMessage(err.response?.data?.detail || 'Lien de vérification invalide ou expiré.')
      })
  }, [token])

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="flex justify-center mb-8">
          <TremorLogo size={40} className="text-gold" />
        </div>

        {status === 'loading' && (
          <div className="space-y-4">
            <Loader2 size={48} className="mx-auto text-gold animate-spin" />
            <p className="font-serif text-lg font-semibold text-ink">Vérification en cours…</p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-4">
            <div className="w-16 h-16 mx-auto rounded-full bg-teal-light flex items-center justify-center">
              <CheckCircle size={32} className="text-teal-dark" />
            </div>
            <h1 className="font-serif text-2xl font-bold text-ink">Email vérifié !</h1>
            <p className="text-[14px] text-ink-muted">{message}</p>
            <button
              onClick={() => navigate('/home')}
              className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-onyx text-paper text-[14px] font-medium hover:bg-onyx-light transition-colors"
            >
              Accéder à TremorApp
            </button>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-4">
            <div className="w-16 h-16 mx-auto rounded-full bg-brick-light flex items-center justify-center">
              <XCircle size={32} className="text-brick" />
            </div>
            <h1 className="font-serif text-2xl font-bold text-ink">Vérification échouée</h1>
            <p className="text-[14px] text-ink-muted">{message}</p>
            <button
              onClick={() => navigate('/login')}
              className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-onyx text-paper text-[14px] font-medium hover:bg-onyx-light transition-colors"
            >
              Retour à la connexion
            </button>
          </div>
        )}

        <p className="mt-12 text-[10px] text-ink-faint">TremorApp · Intelligence Marché</p>
      </div>
    </div>
  )
}
